// extracted by mini-css-extract-plugin
export default {"cloud":"TopicsWordCloudCard_cloud__fi8li","TopicsWordCloudCard":"TopicsWordCloudCard_TopicsWordCloudCard__NrvYa"};